var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "iq-sidebar bg-dark"
  }, [_c('div', {
    staticClass: "iq-sidebar-logo d-flex justify-content-between p-4 mb-5"
  }, [_c('img', {
    staticClass: "img-fluid w-100 mr-2",
    attrs: {
      "src": _vm.logo,
      "alt": "logo"
    }
  }), _vm.toggleButton ? _c('div', {
    staticClass: "iq-menu-bt-sidebar"
  }, [_c('div', {
    staticClass: "iq-menu-bt align-self-center"
  }, [_c('div', {
    staticClass: "wrapper-menu",
    class: {
      open: _vm.isMini
    },
    on: {
      "click": _vm.miniSidebar
    }
  }, [_vm._m(0), _vm._m(1)])])]) : _vm._e()]), _c('div', {
    attrs: {
      "id": "sidebar-scrollbar"
    }
  }, [_c('nav', {
    staticClass: "iq-sidebar-menu",
    class: _vm.horizontal ? 'd-xl-none' : ''
  }, [_c('List', {
    attrs: {
      "items": _vm.items,
      "open": true,
      "horizontal": _vm.horizontal
    }
  })], 1), _c('div', {
    staticClass: "p-3"
  })])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-circle"
  }, [_c('i', {
    staticClass: "ri-more-2-fill"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hover-circle"
  }, [_c('i', {
    staticClass: "ri-more-fill"
  })]);

}]

export { render, staticRenderFns }